<template>
  <div class="section-main__warp">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
          新增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
      width="35%">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
        <el-form-item label="交易量" prop="tradeQuantity">
          <el-input v-model="addForm.tradeQuantity" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="交易金额" prop="tradeAmount">
          <el-input v-model="addForm.tradeAmount" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="交易平台" prop="tradePlatform">
          <el-select v-model="addForm.tradePlatform" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in platformArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易类型" prop="tradeType">
          <el-select v-model="addForm.tradeType" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in typeArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易人" prop="tradePerson">
          <el-input v-model="addForm.tradePerson" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="交易时间" prop="tradeTime">
          <el-date-picker v-model="addForm.tradeTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="tradeRemark">
          <el-input v-model="addForm.tradeRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel('addForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/carbonTrading";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        tradeQuantity: [{ required: true, message: '请输入交易量', trigger: ['blur', 'change'] }],
        tradeAmount: [{ required: true, message: '请输入交易金额', trigger: ['blur', 'change'] }],
        tradePlatform: [{ required: true, message: '请选择交易平台', trigger: ['blur', 'change'] }],
        tradeType: [{ required: true, message: '请选择交易类型', trigger: ['blur', 'change'] }],
        tradeTime: [{ required: true, message: '请选择交易时间', trigger: ['blur', 'change'] }],
        tradePerson: [{ required: true, message: '请输入交易人', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        tradeId: null,
        tradeQuantity: '',
        tradeAmount: '',
        tradePlatform: '',
        tradeType: '',
        tradeTime: '',
        tradePerson: '',
        tradeRemark: ''
      },
      platformArr: [{ 'label': '北京碳排放权交易所', 'value': '北京碳排放权交易所' }, { 'label': '上海碳排放权交易所', 'value': '上海碳排放权交易所' },
      { 'label': '重庆碳排放权交易所', 'value': '重庆碳排放权交易所' }],
      typeArr: [{ 'label': '买入', 'value': '1' }, { 'label': '卖出', 'value': '0' }]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        tradeType: this.searchForm.tradeType
      };
      this.$fetch(api.carbonTrading.queryTradingList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.tradeId = null
      this.addForm.tradeQuantity = ''
      this.addForm.tradeAmount = ''
      this.addForm.tradePlatform = ''
      this.addForm.tradeType = ''
      this.addForm.tradeTime = ''
      this.addForm.tradePerson = ''
      this.addForm.tradeRemark = ''
      this.addVisible = true
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.tradeId) {
            let params = {
              tradeId: this.addForm.tradeId,
              tradeQuantity: this.addForm.tradeQuantity,
              tradeAmount: this.addForm.tradeAmount,
              tradePlatform: this.addForm.tradePlatform,
              tradeType: this.addForm.tradeType,
              tradeTime: this.addForm.tradeTime,
              tradePerson: this.addForm.tradePerson,
              tradeRemark: this.addForm.tradeRemark
            }
            this.$fetch(api.carbonTrading.updateTradingList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              tradeQuantity: this.addForm.tradeQuantity,
              tradeAmount: this.addForm.tradeAmount,
              tradePlatform: this.addForm.tradePlatform,
              tradeType: this.addForm.tradeType,
              tradeTime: this.addForm.tradeTime,
              tradePerson: this.addForm.tradePerson,
              tradeRemark: this.addForm.tradeRemark
            }
            this.$fetch(api.carbonTrading.addTradingList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.tradeId = row.tradeId
      this.addForm.tradeQuantity = row.tradeQuantity
      this.addForm.tradeAmount = row.tradeAmount
      this.addForm.tradePlatform = row.tradePlatform
      this.addForm.tradeType = row.tradeType
      this.addForm.tradeTime = row.tradeTime
      this.addForm.tradePerson = row.tradePerson
      this.addForm.tradeRemark = row.tradeRemark
      this.addVisible = true;
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/trade/del/' + row.tradeId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>
